import "./App.css"
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useEffect,useRef } from "react";
import MasterMap from "./components/masterMap";
import Loader from "./components/loader"
import ModalLRD from "./components/modalLRD";
import ModalWRD from "./components/modalWRD";
import LeftPanel from "./components/leftPanel";
import cloneDeep from 'lodash/cloneDeep';
import axios from "axios";
import "./style.css"
import "./w3.css"
import FileSaver from 'file-saver';
import ModalGuideline from './components/modalGuideline'
import OLVectorLayer from "ol/layer/Vector";
import VectorSource from 'ol/source/Vector';
import GeoJSON from "ol/format/GeoJSON";
import default_lrd_weights from './jsonData/default_lrd_weights.json'
import default_wrd_weights from './jsonData/default_wrd_weights.json'
import {  Fill, Stroke, Style } from "ol/style";
//const baseURL = "http://127.0.0.1:8000/GPSDP/tools";
// const baseURL = "http://127.0.0.1:5001/GPSDP";
const baseURL = "https://bhuvan-nyayavikas.nrsc.gov.in/GPSDP";



function App() {
  const [update,setUpdate]=useState({})
  const [resData,setResData]=useState([])
  const [data, setData] = useState([]);
  const [step, setStep] = useState(0);
  const [edit, setEdit] = useState(false);  
  const [message, setMessage] = useState("");
  const [editedValues, setEdited] = useState([]);
  const [isShpFileUploaded,setIsShpFileUploaded]=useState(false)  
  const [defaultLRDData, setDefaultLRDData] = useState([]);
  const [defaultWRDData, setDefaultWRDData] = useState([]);
  const [WRDTitles, setWRDTitles] = useState([""]);
  const [LRDTitles, setLRDTitles] = useState([""]);
  const [WRDHeader, setWRDHeader] = useState([]);
  const [LRDHeader, setLRDHeader] = useState([]);
  const [maxStep, setMaxStep] = useState([]);
  const [mainMenu, setMenu] = useState("");
  const [loading,setLoading]=useState(false)
  const [states,setStates]=useState()
  const [districts,setDistricts]=useState()
  const [blocks,setBlocks]=useState()
  const [panchayats,setPanchayats]=useState()
  const [statecode,setStateCode]=useState()
  const [distcode,setDistCode]=useState()
  const [blockcode,setBlockCode]=useState()
  const [gpcode,setGPCode]=useState()
  const [loadingState,setLoadingState]=useState(false)  
  const reportTemplateRef = useRef(null);
  const [guidelineModal,setGuidelineModal]=useState(true)
  // const COLORS={"Core Urban":"#fa0202",
  //               "Intensive Agriculture":"#fa0202",
  //               "Peri-Urban":"#b90400",
  //               "Other Urban Areas":"#842b00",
  //               "Village Settlement":"#e60000",
  //               "Mixed Village Settlement":"#f34429",
  //               "Hamlet & Dispersed Household":"#ffaeb0",
  //               "Other Rural Built-up Areas":"#ff807a",
  //               "Industrial area":"#ca8544",
  //               "Recreational / Industrial":"#ca8544",
  //               "Transport Network":"#d35563",
  //               "Transport Infrastructure":"#46505a",
  //               "Crop Land":"#fff978",
  //               "Fallow Land":"#faccab",
  //               "Agriculture Plantation / Orchards":"#fcf31c",
  //               "Agro-forestry":"#fcf31c",
  //               "Aquaculture":"#3069fe",
  //               "Closed Forest":"#006400",
  //               "Open Forest":"#51be41",
  //               "Forest Plantation":"#73cb07",
  //               "Swamp area / Mangrove":"#4ce7a5",
  //               "Grasslands / Grazing Lands":"#b2d718",
  //               "Grazing/Pasture Land":"#b2d718",
  //               "Salt Affected Land":"#e8abf9",
  //               "Gullied land":"#cf0cfc",
  //               "Ravinous Land":"#e30cf5",
  //               "Dense scrub land":"#fb36ff",
  //               "Sparse scrub land":"#c734c0",
  //               "Barren Rocky":"#ff99ff",
  //               "Stony Waste":"#eb85ff",
  //               "Sandy area - Desertic":"#fac846",
  //               "Sandy area - Coastal":"#e4cdff",
  //               "Waterlogged":"#03979b",
  //               "River":"#0430cd",
  //               "Stream":"#0e41cd",
  //               "Canal / Drain":"#2a33f2",
  //               "Lakes / Pond":"#5f99ff",
  //               "Reservoirs / Tank":"#319af5",
  //               "Snow covered area":"#cccccc",
  //               "Glacial area":"#c8ffff",
  //               "Shifting Cultivation area":"#d98ad9",
  //               "Mining / Quarry / Mining Dump":"#caad30",
  //               "Rann":"#e0e6fc",
  //               "Salt pan":"#cb96e5"}


const [COLORS,setColors]=useState({})
  
  
  var gtPoints= new OLVectorLayer({
    title: 'LRD WRD',  visible: true, source: new VectorSource({
        features: new GeoJSON({ featureProjection: 'EPSG:3857' }).readFeatures({ "type": "GeometryCollection", "geometries": [ ] })
      }),  
      style:  function (feature) {
        //console.log(feature.id_);
        return new Style({
          stroke: new Stroke({
            color: "rgba(155,155,155, 0.9)",
            width: 1,
          }),
          fill: new Fill({
            color: COLORS[feature.id_]!=undefined?COLORS[feature.id_]:'rgb(0,0,0,0)'
          }),
        })
      }, 
    });


  const [results]=useState(gtPoints)


//axios.defaults.proxy.host = "192.168.0.9"
//axios.defaults.proxy.port = 8080
//axios.defaults.proxy.auth.username = "rrscnorth"
//axios.defaults.proxy.auth.password = "NRSC@User"

  const fetchStates=(code,type="states")=>{    
    // console.log(code,type)
    setLoadingState(true)
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json")
if(type==="states"){
  
var raw = JSON.stringify({
  "query": "query StateQuery {\n  allStates(orderBy: STNAME_ASC) {\n    nodes {\n      stcode\n      stname\n    }\n  }\n}\n",
  "variables": {}
});
}
else if(type=="district"){
  setPanchayats([])
  setBlocks([])
  setDistricts([])  
  setStateCode(code)
  var raw = JSON.stringify({
    "query": "query DistrictQuery(\n  $condition: DistrictCondition!\n) {\n  allDistricts(orderBy: DTNAME_ASC, condition: $condition) {\n    nodes {\n      dtcode\n      dtname\n    }\n  }\n}\n",
    "variables": {
      "condition": {
        "stcode": code
      }
    }
  });
}
else if(type=="block"){
  setPanchayats([])
  setBlocks([])
  setDistCode(code)
  var raw = JSON.stringify({
    "query": "query BlockQuery(\n  $condition: BlockCondition!\n) {\n  allBlocks(orderBy: BPNAME_ASC, condition: $condition) {\n    nodes {\n      bpcode\n      bpname\n    }\n  }\n}\n",
    "variables": {
      "condition": {
        "dtcode": code,
        "stcode": statecode
      }
    }
  });
}

else if(type=="gp"){
  
  setPanchayats([])
  setBlockCode(code)
  var raw = JSON.stringify({
    "query": "query PanchayatQuery(\n  $condition: PanchayatCondition!\n) {\n  allPanchayats(orderBy: GP_NAME_ASC, condition: $condition) {\n    nodes {\n      gpcode\n      gpName\n    }\n  }\n}\n",
    "variables": {
      "condition": {
        "bpcode": code,
        "dtcode": distcode,
        "stcode": statecode
      }
    }
  });
}
else if(type=="gpcode"){
  setGPCode(code)
  setLoadingState(false)
}

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};
if(type!="gpcode"){
fetch("https://bhuvan-panchayat3.nrsc.gov.in/graphql", requestOptions)
  .then(response => response.json())
  .then((result) => {
    setLoadingState(false)
    // console.log("states fetch",result)
    if(result.data.allStates!=undefined){
    let st=result.data.allStates.nodes.filter((item)=>item.stname==="Chhattisgarh" || item.stname==="Madhya Pradesh" )
    setStates(st)
  }
  else if(result.data.allDistricts!=undefined){
    let dt=result.data.allDistricts.nodes.filter((item)=>item.dtname==="Kondagaon" || item.dtname==="Sehore" || item.dtname==="Rajouri")
    setDistricts(dt)
  }
  else if(result.data.allBlocks!=undefined){
    setBlocks(result.data.allBlocks.nodes)
  }
  else if(result.data.allPanchayats!=undefined){
    setPanchayats(result.data.allPanchayats.nodes)
  }
   })
  .catch((error) =>{  console.log('error', error);
                      setLoadingState(false)});
                      
}
    
  }
  
  const submitData = () => {    
    setDistricts()
    setBlocks()
    setPanchayats()

    setStateCode()
    setDistCode()
    setBlockCode()
    setGPCode()
    setLoading(true)
    var bodyFormData = new FormData();
    bodyFormData.append('statecode', statecode);
    bodyFormData.append('districtcode', distcode);
    bodyFormData.append('blockcode', blockcode);
    bodyFormData.append('gp_code', gpcode);
    bodyFormData.append('isShpFileUploaded',isShpFileUploaded)
    
    
    

    // bodyFormData.append('statecode', '23');
    // bodyFormData.append('districtcode', '445');
    // bodyFormData.append('blockcode', '4349');
    // bodyFormData.append('gp_code', '149322');

    // console.log(mainMenu);

  //  bodyFormData.append('sel_activity', 'WRD');
    
    bodyFormData.append('sel_activity', mainMenu);
    bodyFormData.append('sel_intervention', 'All');
    bodyFormData.append('weights', editedValues);  
    axios.post(baseURL+"/tools",bodyFormData)
    .then(res => {
      if(res.status===200)
      { setLoading(false)
        // console.log("testing displayed here",res.data)
        let newdata=res.data.features.filter((item,i)=>item.id!="none")
        let geojsonData = {
          type: 'FeatureCollection',
          features: newdata.map(feature => ({
            type: 'Feature',
            id: feature.id,
            properties: feature.properties,
            geometry: feature.geometry
          }))
        };
        // console.log("testing displayed here2",newdata)
        setResData(JSON.stringify(newdata))
        let random={}
        geojsonData.features.map((item,i)=>{
          let randomColor = Math.floor(Math.random()*16777215).toString(16);
          COLORS[item.id]=`#${randomColor}`
          random[item.id]=`#${randomColor}`
          // console.log("i value",`${randomColor}`)
        })
        // console.log("random",random)
        setColors(COLORS)
        setUpdate(random)
        results.getSource().clear();
        results.getSource().addFeatures(new GeoJSON({ featureProjection: 'EPSG:3857' }).readFeatures(geojsonData))
        // var requestOptions = {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({inputData:res.data}),
        //   redirect: 'follow'
        // };
        // fetch("http://172.17.102.84:5000/download",requestOptions
        //   )
        // .then((result)=>result.blob())
        // .then((blob)=>FileSaver.saveAs(blob, 'File.zip'))
        // .catch((error)=>console.log("error",error))
        // //alert("Results are generated successfully.")
        fetch(baseURL+"/download",{method:'POST',body:JSON.stringify({activity:mainMenu+"_Product"})})
        .then((result)=>result.blob())
        .then((blob)=>{alert("Results are generated successfully. Click OK to Download Files.");FileSaver.saveAs(blob, 'File.zip');})
        .catch((error)=>console.log("error",error))
      }
    })
    .catch(err =>{
      setLoading(false)
      console.log(err);
      alert("Some Error Occurred!")
    }); 
    handleCloseModal();
  
  };
  const handleDefault = () => {
    submitData();
    
  };
  
  const updateMenu = (val) => {
    setEdited([]);
    results.getSource().clear();
    setMenu(val);
    if(val==="LRD")
    {
     setData(cloneDeep(defaultLRDData)  );
     
     setStep(-1);
     setMaxStep(6);
    }
    else
    {
      setData(cloneDeep(defaultWRDData));
      setStep(-1);
      setMaxStep(4);
    }
   // console.log("default2",JSON.stringify(defaultWRDData))
  };
  const handleCloseModal =()=>{
    setMenu("");
    setEdit(false);
  };

  useEffect(() => {
    reader()
    reader2()
    fetchStates()
    
  }, []);

  const reader = () => {
    //const bstr = e.target.result;
    for (var i = 0; i < default_lrd_weights.length; ++i) {      
      const jsonData = default_lrd_weights[i]
      setLRDTitles((LRDTitles) => [...LRDTitles]);
      setDefaultLRDData((defaultLRDData) => [...defaultLRDData, jsonData]);
      setLRDHeader((LRDHeader) => [...LRDHeader, Object.keys(jsonData[0]).map((LRDHeader) => <th key={LRDHeader}>{LRDHeader}</th>)]);
     
    }
    //console.log("default_data",default_lrd_weights)
    
  };

  const reader2 = () => {
    //const bstr = e.target.result;
    for (var i = 0; i < default_wrd_weights.length; ++i) {     
      const jsonData = default_wrd_weights[i]
      setWRDTitles((WRDTitles) => [...WRDTitles]);
      setDefaultWRDData((defaultWRDData) => [...defaultWRDData, jsonData]);
      setWRDHeader((WRDHeader) => [...WRDHeader, Object.keys(jsonData[0]).map((WRDHeader) => <th key={WRDHeader}>{WRDHeader}</th>)]);
    }
    
  };

  const handleFileUpload =()=>{
    setIsShpFileUploaded(true)
  }


  const handleEditButton = () => {
    if(!edit)
    {
      if(window.confirm("Do you want to edit these weights.")) {
        setEdit(!edit);
      }
    }
    else
      setEdit(!edit);
  };
  const handleNextButton = () => {
    if (step < maxStep)
    {
      setStep(step + 1);
      setEdit(false);
    }
    else
    {
      if(editedValues.findIndex((e) => e[4] === true )>=0)
      {
        alert("Please correct errors before submitting");
      }
     
      else if (window.confirm("Are you sure you want to submit it?")) {
          submitData();
      }
    }
  };
 
  const handleBackButton = () => {
    if (step > 0) 
    {
      setStep(step -1);
      setEdit(false);
    }
  };
  const handleResetButton = () => {
    const editedData = editedValues;
    var got = editedData.findIndex((e) => e[0] === step );
    // console.log(got);
    while (got>-1)
    {
      editedData.splice(got,1);
      got = editedData.findIndex((e) => e[0] === step );
      // console.log(got);
    }
    setEdited(editedData);
    var curr_data= cloneDeep( data);
    if(mainMenu==="LRD")
    {
      curr_data[step]=cloneDeep(defaultLRDData[step]);
    }
    else
    {
      curr_data[step]=cloneDeep(defaultWRDData[step]);
    }
    setData(curr_data);
  };
  const validateInput = (index,i,j,val) => {
    setEdit(true);
    var error=false;
    if(val==="NIL" || val==="Y" || val==="P" || Number.isInteger(parseInt(val))  )
    {
      if(Number.isInteger(parseInt(val)))
      {
        if(parseInt(val) >10)
        {
          setMessage( "Value should be less or equal to 10" );
          error=true;
        }
      }
    }
    else
    {
      setMessage("Please check input");
      error=true;
    }
    const editedData = editedValues;
    var got = editedData.findIndex((e) => e[0] === index && e[1] === i && e[2] === j);
    
    if(got>=0){
      editedData[got]=[index,i,j,val,error];
      setEdited(editedData);
    }
    else {
      editedData.push([index, i, j, val, error]);
      setEdited(editedData);
    }
    // console.log(editedValues);
    //setEdit(true);
    got = editedData.findIndex((e) => e[4] === true );
    // console.log(got);
    if(got<0)
    {
      //setEdit(false);
      setMessage("");
    }
  };

  const handleGuidelineModal=()=>{
    console.log("guideline")
    setGuidelineModal(false)
  }

  const handleCapture=(colors)=>{
    console.log("handleCapture")
    setUpdate(colors)
  }

  return (

    <div style={{display:'flex',flexDirection:'column',justifyContent:'center'}} >
      

<div id="topcontainer">
  <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
    <a href="https://www.india.gov.in/" target="blank"><img src={require('./img/Emblem.png')}  alt="Emblem"/></a>
    <a href="https://www.isro.gov.in/" target="blank"><img src={'https://bhuvan-panchayat3.nrsc.gov.in/SISDP/Img/ISRO.png'} alt="ISRO logo"/></a>
    <a href="https://bhuvan-panchayat3.nrsc.gov.in/index.html" target="blank" style={{textDecoration: 'none',fontFamily: 'cursive',fontWeight: 'bold',fontStyle: 'italic',alignSelf:'center'}}></a>
  </div>
  <div id="center">
      <h2>SISDP (Space based Information Support for Decentralized Planning) </h2>
      <p>Geospatial Technology platform for G-governance</p>
      <div style={{}}>
        <a href="https://bhuvan.nrsc.gov.in/home/index.php"  target="blank"><img alt="NRSC logo" src={require('./img/bhuvanLogo.png')} width={50}  /></a>
        <a href="https://bhuvan-panchayat3.nrsc.gov.in/index.html" style={{width:200,alignSelf:'center'}} target="blank"><img alt="NRSC logo" src={require('./img/BP.png')} width={200} /></a>
      </div>
  </div>
    <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
      <a href="https://amritmahotsav.nic.in/" target="blank"><img alt="Azadi logo" src={require('./img/Azadi.png')} width={120} /></a>
      <a href="https://www.nrsc.gov.in/" style={{display:'flex',flexDirection:'column',justifyContent:'center'}} target="blank"><img alt="NRSC logo" src={require('./img/NRSC.png')} width={120} /></a>
    </div>
    
</div>

{loading?
    <div style={{display:'flex',alignSelf:'center',justifyContent:'center',height:650}}>
      <Loader/>
      </div> :
      <div>
<LeftPanel 
        setMenu={updateMenu} 
        key={Math.random()} 
        results={results}
        resData={resData}      
        colors={[update]}        
        mainMenu={mainMenu}/>



      
      <ModalLRD
        loading={loading}
        loadingState={loadingState}
        showModal={mainMenu}
        excelData={data}
        origionalData={defaultLRDData}
        headerData={LRDHeader}
        progressStep={step}
        editData={edit}
        ttitle={LRDTitles}
        maxSteps={maxStep}
        handleFileUpload={handleFileUpload}
        errorMessage={message}
        validateIt={validateInput}
        handleBack={handleBackButton}
        handleNext={handleNextButton}
        handleClose={handleCloseModal}
        handleReset={handleResetButton}
        handleEdit={handleEditButton}
        setExcelData={setData}
        handleDefaultWeights={handleDefault}
        states={states!=undefined && states.length>0?states:[]}
        fetchStates={fetchStates}
        districts={districts!=undefined && districts.length>0?districts:[]}
        blocks={blocks!=undefined && blocks.length>0?blocks:[]}
        panchayats={panchayats!=undefined && panchayats.length>0?panchayats:[]}
        statecode={statecode}
        distcode={distcode}
        blockcode={blockcode}
        gpcode={gpcode}
        baseURL={baseURL}
      />
      <ModalWRD
        showModal={mainMenu}
        excelData={data}
        origionalData={defaultWRDData}
        headerData={WRDHeader}
        progressStep={step}
        editData={edit}
        ttitle={WRDTitles}
        maxSteps={maxStep}
        errorMessage={message}
        validateIt={validateInput}
        handleFileUpload={handleFileUpload}
        handleBack={handleBackButton}
        handleNext={handleNextButton}
        handleClose={handleCloseModal}
        handleReset={handleResetButton}
        handleEdit={handleEditButton}
        setExcelData={setData}
        handleDefaultWeights={handleDefault}
        states={states!=undefined && states.length>0?states:[]}
        fetchStates={fetchStates}
        districts={districts!=undefined && districts.length>0?districts:[]}
        blocks={blocks!=undefined && blocks.length>0?blocks:[]}
        panchayats={panchayats!=undefined && panchayats.length>0?panchayats:[]}
        statecode={statecode}
        distcode={distcode}
        blockcode={blockcode}
        gpcode={gpcode}
        loading={loading}
        loadingState={loadingState}
        baseURL={baseURL}
      />

      {/* <ModalGuideline
        handleGuidelineModal={handleGuidelineModal}
        guidelineModal={guidelineModal}
      /> */}
      </div>}
      
      <footer class="w3-indigo" style={{display:'flex',flexDirection:'column',width:'100%'}}>
  <div class="f_col">
      <div>
        <ul>
          <li><h4> Quick Links</h4></li>
          <li> <a target="_blank" href="https://bhuvan-panchayat3.nrsc.gov.in/index.html">Bhuvan Panchayat Portal </a></li>
          <li> <a target="_blank" href="https://bhuvan.nrsc.gov.in/home/index.php">Bhuvan</a></li>
      </ul></div>
      <div>
        <ul>
          <li style={{color:'#1d3e93'}}>&nbsp;</li>
          <li> <a target="_blank" href="https://www.nrsc.gov.in/">National Remote Sensing Centre (NRSC)</a></li>
          <li> <a target="_blank" href="http://www.isro.gov.in/">Indian Space Research Organisation (ISRO)</a></li>
          <li> <a target="_blank" href="https://panchayat.gov.in/">Ministry of Panchayati Raj</a></li> 
        </ul>
      </div>
      <div>
        <ul><li style={{color:'#1d3e93'}}>&nbsp;</li>
              <label id="Visits">Last Updated: 01 Apr, 2024</label>
        
                  
                  
        </ul>   
      </div>
  </div>
 
  {/* <div class="f_col">
    <span><a href="#" id="Copyright">Copyright Policy</a></span>
    <span><a href="#" id="Hyperlink">Hyperlinking Policy</a></span>
    <span><a href="#" id="Disclaimer">Disclaimer</a></span>
    <span><a href="#" id="Terms">Terms &amp; Conditions</a></span>
  </div> */}
  <div className="footer">
    <p>©2023 Copyright 2023 NRSC,ISRO. All Rights Reserved</p>
  </div> 
</footer>
    </div>
  );
}
export default App;